// extracted by mini-css-extract-plugin
export default {"pageContainer":"Style_pageContainer__Xj9CR"};